module.exports = __webpack_public_path__ + "img/head@2x.7930ffcd.png";